<template>
  <span
    v-on="$listeners"
    class="v-icon"
    :class="{ 'stroke-width': strokeWidth !== null, fill: fill !== null }"
    :style="style"
    v-html="icon"
  ></span>
</template>

<script>
export default {
  name: 'v-icon',

  props: {
    size: {
      type: String,
      default: '1em'
    },

    fontSize: {
      type: String,
      default: '1em'
    },

    strokeWidth: {
      type: String,
      default: null
    },

    color: {
      type: String,
      default: 'inherit'
    },

    fill: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      icon: null
    }
  },

  computed: {
    style() {
      return {
        width: this.size,
        height: this.size,
        fontSize: this.fontSize,
        color: this.color,
        '--v-icon-stroke-width': this.strokeWidth,
        '--v-icon-fill': this.fill,
        ...('debug' in this.$attrs ? { border: '1px solid' } : {})
      }
    }
  },

  created() {
    this.setIcon()
  },

  updated() {
    this.setIcon()
  },

  methods: {
    setIcon() {
      const icon = this.$slots.default && this.$slots.default[0].text.trim()
      try {
        this.icon = icon ? require(`!svg-inline-loader!@/assets/icons/${icon}.svg`) : icon
      } catch (e) {
        console.log(e)
        this.icon = icon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;

  &.stroke-width {
    :global(svg) {
      stroke-width: var(--v-icon-stroke-width);
    }
  }

  &.fill {
    :global(svg) {
      fill: var(--v-icon-fill);
    }
  }

  :global(svg) {
    height: 1em;
    width: 1em;
    stroke: currentColor;
    transition: stroke-width 0.5s ease-in-out;
  }
}
</style>
